export const zhongfuMcc = [
    {
      "text": "⼩吃",
      "value": "1",
      "children": [
        {
          "text": "早餐",
          "value": "0101"
        },
        {
          "text": "烧烤",
          "value": "0102"
        },
        {
          "text": "⼤排档",
          "value": "0103"
        },
        {
          "text": "路边摊",
          "value": "0104"
        },
        {
          "text": "其他",
          "value": "0199"
        }
      ]
    },
    {
      "text": "餐饮",
      "value": "2",
      "children": [
        {
          "text": "快餐",
          "value": "0201"
        },
        {
          "text": "⽕锅",
          "value": "0202"
        },
        {
          "text": "⾃助餐",
          "value": "0203"
        },
        {
          "text": "烤⾁",
          "value": "0204"
        },
        {
          "text": "海鲜",
          "value": "0205"
        },
        {
          "text": "其他",
          "value": "0299"
        }
      ]
    },
    {
      "text": "饮品甜点",
      "value": "3",
      "children": [
        {
          "text": "奶茶",
          "value": "0501"
        },
        {
          "text": "咖啡",
          "value": "0502"
        },
        {
          "text": "⾯包甜点",
          "value": "0503"
        },
        {
          "text": "茶馆",
          "value": "0504"
        },
        {
          "text": "酒吧",
          "value": "0505"
        },
        {
          "text": "其他",
          "value": "0599"
        }
      ]
    },
    {
      "text": "⽔果⽣鲜",
      "value": "4",
      "children": [
        {
          "text": "新鲜⽔果",
          "value": "0301"
        },
        {
          "text": "蔬菜蛋品",
          "value": "0302"
        },
        {
          "text": "⾁类",
          "value": "0303"
        },
        {
          "text": "海鲜⽔产",
          "value": "0304"
        },
        {
          "text": "冷冻⻝品",
          "value": "0305"
        },
        {
          "text": "其他",
          "value": "0399"
        }
      ]
    },
    {
      "text": "⽣活服务",
      "value": "5",
      "children": [
        {
          "text": "美容",
          "value": "0401"
        },
        {
          "text": "美发",
          "value": "0402"
        },
        {
          "text": "洗⾐",
          "value": "0403"
        },
        {
          "text": "管道疏通",
          "value": "0404"
        },
        {
          "text": "维修",
          "value": "0405"
        },
        {
          "text": "汽⻋美容",
          "value": "0406"
        },
        {
          "text": "搬家",
          "value": "0407"
        },
        {
          "text": "回收",
          "value": "0408"
        },
        {
          "text": "⽂印图⽂",
          "value": "0409"
        },
        {
          "text": "照相馆",
          "value": "0410"
        },
        {
          "text": "书报摊",
          "value": "0411"
        },
        {
          "text": "家政",
          "value": "0412"
        },
        {
          "text": "物业",
          "value": "0413"
        },
        {
          "text": "快递",
          "value": "0414"
        },
        {
          "text": "彩票销售",
          "value": "0415"
        },
        {
          "text": "加油站",
          "value": "0416"
        },
        {
          "text": "停⻋场",
          "value": "0417"
        },
        {
          "text": "代驾",
          "value": "0418"
        },
        {
          "text": "旅馆",
          "value": "0419"
        },
        {
          "text": "保险",
          "value": "0420"
        },
        {
          "text": "便⺠缴费",
          "value": "0421"
        },
        {
          "text": "便⺠服务",
          "value": "0422"
        },
        {
          "text": "爱⼼服务",
          "value": "0423"
        },
        {
          "text": "宠物店",
          "value": "0424"
        },
        {
          "text": "⾦融服务",
          "value": "0425"
        },
        {
          "text": "其他",
          "value": "0499"
        }
      ]
    },
    {
      "text": "服饰鞋品",
      "value": "6",
      "children": [
        {
          "text": "⾐服服饰",
          "value": "0601"
        },
        {
          "text": "鞋品",
          "value": "0602"
        },
        {
          "text": "饰品",
          "value": "0603"
        },
        {
          "text": "童装",
          "value": "0604"
        },
        {
          "text": "运动服饰",
          "value": "0605"
        },
        {
          "text": "服装鞋品定制",
          "value": "0606"
        },
        {
          "text": "其他",
          "value": "0699"
        }
      ]
    },
    {
      "text": "休闲娱乐",
      "value": "7",
      "children": [
        {
          "text": "KTV",
          "value": "0701"
        },
        {
          "text": "⽹吧",
          "value": "0702"
        },
        {
          "text": "洗浴中⼼",
          "value": "0703"
        },
        {
          "text": "电玩",
          "value": "0704"
        },
        {
          "text": "游乐城",
          "value": "0705"
        },
        {
          "text": "⾜浴按摩",
          "value": "0706"
        },
        {
          "text": "桌游棋牌",
          "value": "0707"
        },
        {
          "text": "剧场",
          "value": "0708"
        },
        {
          "text": "电影院",
          "value": "0709"
        },
        {
          "text": "其他",
          "value": "0799"
        }
      ]
    },
    {
      "text": "健康保健",
      "value": "8",
      "children": [
        {
          "text": "药店",
          "value": "0801"
        },
        {
          "text": "中医诊所",
          "value": "0802"
        },
        {
          "text": "健身会所",
          "value": "0803"
        },
        {
          "text": "舞蹈瑜伽",
          "value": "0804"
        },
        {
          "text": "运动场馆",
          "value": "0805"
        },
        {
          "text": "⼝腔⻮科",
          "value": "0806"
        },
        {
          "text": "卫⽣所",
          "value": "0807"
        },
        {
          "text": "推拿理疗",
          "value": "0808"
        },
        {
          "text": "其他",
          "value": "0899"
        }
      ]
    },
    {
      "text": "教育培训",
      "value": "9",
      "children": [
        {
          "text": "早教中⼼",
          "value": "0901"
        },
        {
          "text": "⾳乐培训",
          "value": "0902"
        },
        {
          "text": "外语培训",
          "value": "0903"
        },
        {
          "text": "⼉童才艺",
          "value": "0904"
        },
        {
          "text": "学习辅导",
          "value": "0905"
        },
        {
          "text": "驾校",
          "value": "0906"
        },
        {
          "text": "技能培训",
          "value": "0907"
        },
        {
          "text": "⾼校⻝堂",
          "value": "0908"
        },
        {
          "text": "其他",
          "value": "0999"
        }
      ]
    },
    {
      "text": "杂货电⼦",
      "value": "10",
      "children": [
        {
          "text": "杂货店",
          "value": "1001"
        },
        {
          "text": "五⾦店",
          "value": "1002"
        },
        {
          "text": "厨卫洁具",
          "value": "1003"
        },
        {
          "text": "建材",
          "value": "1004"
        },
        {
          "text": "电⼦产品",
          "value": "1005"
        },
        {
          "text": "软件商店",
          "value": "1006"
        },
        {
          "text": "烟草",
          "value": "1007"
        },
        {
          "text": "其他",
          "value": "1099"
        }
      ]
    },
    {
      "text": "出⾏",
      "value": "11",
      "children": [
        {
          "text": "出租⻋",
          "value": "1101"
        },
        {
          "text": "汽⻋租赁",
          "value": "1102"
        },
        {
          "text": "⾃⾏⻋/维修",
          "value": "1103"
        },
        {
          "text": "客运",
          "value": "1104"
        },
        {
          "text": "电⼦其他",
          "value": "1199"
        }
      ]
    }
  ]